<template>
<div>
    <div class="content-header row"></div>
    <div class="content-body"><!-- stats -->

        <div class="row match-height" v-if="editing">
            <div class="col-md-12"><div class="card">
                <div class="card-header">
                    <h4 class="card-title"><i class="icon-profile"></i> {{$t('users.addUsr.title.change')}}</h4>
                    <div class="heading-elements">
                        <button type="button" class="btn btn-warning" @click="cancelChanges()" data-html="true" :title=" $t('tasks.hint.close')">
                            <i style="color: #FFFFFF" class="icon-cross"></i>
                        </button>
                    </div>
                </div>
            
                <div class="card-body">
                    <div class="card-block">
                    <form class="form">    
                    <!--body block-->
                        
                            <div class="row">
                                <div class="col-md-3">
                                    <div class="form-group">
                                        <label for="projectinput1">{{$t('users.table.name')}}</label>
                                        <input type="text" class="form-control" placeholder="" v-model="changeUsr.username">
                                    </div>
                                </div>
                                <!-- <div class="col-md-3">
                                    <div class="form-group">
                                        <label for="roleSelection">{{$t('users.table.roles')}}</label>
                                        <select id="roleSelection" class="form-control" v-model="changeUsr.role">
                                            <option v-for="role in $store.state.roles" v-bind:value="role.val">{{ $t('titles.roles.' + role.val + '.title') }}</option>
                                        </select>
                                    </div>
                                </div> -->
                                <!-- <div class="col-md-3">
                                    <label>{{$t('users.table.roles')}}</label>
                                    <div class="input-group">
                                        <div class="form-control border-primary" style="background-color: #eceeef" id="roles" @click="showRoles = !showRoles">
                                            {{$t('users.table.roles')}}
                                        </div>

                                        <div class="input-group-append">
                                            <button type="button" class="btn btn-primary btn-round" @click="showRoles = !showRoles">
                                                <a class="dropdown-toggle" style="color: white"></a>
                                            </button>
                                        </div>
                                        <div class="dropdown-menu" v-if="showRoles">
                                            <button class="dropdown-item" type="button" v-for="(role, index) in $store.state.roles" :key="index" @click="showRoles = false; addRole(role.val)">
                                                {{$t('titles.roles.' + role.val + '.title')}}
                                            </button>
                                        </div>
                                    </div>
                                    
                                    <div class="row"><div class="col-md-12">
                                            <div class="form-group" v-if="changeUsr.roles.length > 0">
                                                <span v-for="(role,index) in changeUsr.roles" :key="index" class="btn tag-default btn-warning" style="margin: 0.2rem">
                                                    {{$t('titles.roles.' + role + '.title')}} <a @click="changeUsr.roles.splice(index, 1)" data-html="true" :title=" $t('equipm.hint.delete')"><i class="icon-bin"></i></a>
                                                </span>
                                            </div></div>
                                    </div>                             
                                </div> -->
                                
                                <div class="col-md-3">
                                    <div class="form-group">
                                        <label for="projectinput4">{{$t('users.table.phone')}}</label>
                                        <input type="text" class="form-control" placeholder="0991231212" v-model="changeUsr.phone">
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="form-group">
                                        <label for="projectinput3">{{$t('users.table.login')}}</label>
                                        <input type="text" class="form-control" placeholder="" v-model="changeUsr.login">
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="form-group" style="padding-top:35px;">
                                        <!-- <label for="projectinput3">{{$t('users.table.active')}}</label> -->
                                       <!-- <input type="checkbox" v-model="changeUsr.active" id="remember-me" class="chk-remember"> -->
                                       <toggle-button  v-model="changeUsr.active" :labels="true"/>
                                    </div>
                                </div>
                            </div>
                    <!--body block-->
                    <div class="form-actions right">
                        <button type="button" class="btn btn-primary" @click="editUser"><i class="icon-cloud-upload"></i> {{$t('users.saveChanges')}}</button>
                    </div>
                    </form>
                </div>
            </div>

            </div></div>
        </div>


        <div class="row match-height" v-if="adding">
            <div class="col-md-12"><div class="card">
                <div class="card-header">
                    <h4 class="card-title"><i class="icon-user-plus"></i> {{$t('users.addUsr.title.add')}}</h4>
                    <div class="heading-elements">
                        <button type="button" class="btn btn-warning" @click="cancelChanges()" data-html="true" :title=" $t('tasks.hint.close')">
                            <i style="color: #FFFFFF" class="icon-cross"></i>
                        </button>
                    </div>
                </div>
            
                <div class="card-body">
                    <div class="card-block">
                    <form class="form">    
                    <!--body block-->
                        
                            <div class="row">
                                <div class="col-md-3">
                                    <div class="form-group">
                                        <label for="projectinput3">{{$t('users.table.login')}}</label>
                                        <input type="text" class="form-control" placeholder="" v-model="changeUsr.login">
                                    </div>
                                    
                                    
                                </div>
                                <div class="col-md-3">
                                    <div class="form-group">
                                        <label for="projectinput4">{{$t('users.table.password')}}</label>
                                        <input type="password" class="form-control" placeholder="*************" v-model="changeUsr.password">
                                    </div>
                                    
                                    
                                </div>
                                
                                <div class="col-md-3">
                                    <div class="form-group">
                                        <label for="projectinput1">{{$t('users.table.name')}}</label>
                                        <input type="text" class="form-control" placeholder="" v-model="changeUsr.username">
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="form-group">
                                        <label for="projectinput4">{{$t('users.table.phone')}}</label>
                                        <input type="text" class="form-control" placeholder="0991231212" v-model="changeUsr.phone">
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                
                                <div class="col-md-3">
                                    <!-- <div class="form-group">
                                        <label for="roleSelection">{{$t('users.table.roles')}}</label>
                                        <select id="roleSelection" class="form-control" v-model="changeUsr.role">
                                            <option v-for="(role, index) in $store.state.roles" :key="index" v-bind:value="role.val" @click="addRole(role.val)">{{ $t('titles.roles.' + role.val + '.title') }}</option>
                                        </select>
                                    </div> -->
                                    <label>{{$t('users.table.roles')}}</label>
                                    <div class="input-group">
                                        <div class="form-control border-primary" style="background-color: #eceeef" id="roles" @click="showRoles = !showRoles">
                                            {{$t('users.table.roles')}}
                                        </div>

                                        <div class="input-group-append">
                                            <button type="button" class="btn btn-primary btn-round" @click="showRoles = !showRoles">
                                                <a class="dropdown-toggle" style="color: white"></a>
                                            </button>
                                        </div>
                                        <div class="dropdown-menu" v-if="showRoles">
                                            <button class="dropdown-item" type="button" v-for="(role, index) in $store.state.roles" :key="index" @click="showRoles = false; addRole(role.val)">
                                                {{$t('titles.roles.' + role.val + '.title')}}
                                            </button>
                                        </div>
                                    </div>
                                    
                                    <div class="row"><div class="col-md-12">
                                            <div class="form-group" v-if="changeUsr.roles.length > 0">
                                                <span v-for="(role,index) in changeUsr.roles" :key="index" class="btn tag-default btn-warning" style="margin: 0.2rem">
                                                    {{$t('titles.roles.' + role + '.title')}} <a @click="changeUsr.roles.splice(index, 1)" data-html="true" :title=" $t('equipm.hint.delete')"><i class="icon-bin"></i></a>
                                                </span>
                                            </div></div>
                                    </div>                             
                                </div>
                                <div class="col-md-3">
                                    <div class="form-group">
                                        <label for="projectinput3">{{$t('users.table.email')}}</label>
                                        <input type="text" class="form-control" placeholder="E-mail" v-model="changeUsr.email">
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="form-group">
                                        <label for="edrpo">{{$t('users.table.edrpo')}}</label>                                              
                                        <div class="position-relative has-icon-left">
                                            <input type="text" id="edrpo" class="form-control" placeholder="Search by EDRPO (42314105)" @keyup.enter="findClient()" v-on:change="findClient()" v-model="changeUsr.edrpo">
                                            <div class="form-control-position">
                                                <a @click="findClient()" data-html="true" :title=" $t('users.hint.find')"><i class="icon-search4" ></i></a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="form-group">
                                        <label for="nameClient">{{$t('users.table.nameClient')}}</label>
                                        <input type="text" id="nameClient" class="form-control" placeholder="" v-model="changeUsr.nameClient" disabled>
                                    </div>
                                </div>
                            </div>

                    <div class="form-actions right">
                        <button type="button" class="btn btn-primary" @click="saveChanges"><i class="icon-cloud-upload"></i> {{$t('users.saveChanges')}}</button>
                    </div>
                    </form>
                </div>
            </div>

            </div></div>
        </div>

        <div class="row match-height">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header">
                        <h4 class="card-title"><i class="icon-users2"></i> {{ $t('titles.users')}}</h4>
                        <!-- <div class="heading-elements">
                            <button v-if="$store.state.listRole.dispatcher || $store.state.listRole.admin" type="button" class="btn btn-warning" @click="adding = true; editing = false; clearChange()" data-html="true" :title=" $t('users.addUsr.title.add')">
                                <i style="color: #FFFFFF" class="icon-user-plus"></i>
                            </button>
                        </div> -->
                    </div>
                    <div class="card-body">
                        <div class="card-block pb-0">
                            <div class="">
                                <fieldset class="form-group position-relative" data-html="true" :title=" $t('tasks.hint.find')">
                                    <input type="text" class="form-control form-control-lg input-lg" placeholder="" v-model="filterStr">
                                    <div class="form-control-position">
                                        <i class="icon-search4 font-medium-4"></i>
                                    </div>
                                </fieldset>
                            </div>
                        </div>
                        <div class="table-responsive">
                            <table class="table table-hover mb-0">
                                <thead>
                                    <tr>
                                        <th>{{$t('users.table.login')}}</th>
                                        <th>{{$t('users.table.name')}}</th>
                                        <th>{{$t('users.table.nameClient')}}</th>
                                        <!-- <th>{{$t('users.table.roles')}}</th> -->
                                        <th>{{$t('users.table.phone')}}</th>
                                        <th>{{$t('users.table.email')}}</th>
                                        <th>{{$t('users.table.dtReg')}}</th>
                                        <th>{{$t('users.table.active')}}</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="user in paginatedData" :key="user.userGuid">
                                        <td :data-title="$t('users.table.login')" class="text-truncate"><a>{{user.login}}</a></td>
                                        <td :data-title="$t('users.table.name')" class="text-truncate">{{user.name}}</td>
                                        <td :data-title="$t('users.table.nameClient')">{{user.nameClient}}</td>
                                        <!-- <td :data-title="$t('users.table.roles')" >
                                            <span class="tag tag-default" style="margin-right: 5px" v-for="roles in user.role" :key="roles" :class="$t('titles.roles.' + roles + '.class')">
                                                {{ $t('titles.roles.' + roles + '.title') }}
                                            </span>
                                        </td> -->
                                        <td :data-title="$t('users.table.phone')" class="text-truncate"><span class="tag tag-default tag-success">{{user.tel}}</span></td>
                                        <td :data-title="$t('users.table.email')" class="text-truncate"><span class="tag tag-default tag-success">{{user.email}}</span></td>
                                        <td :data-title="$t('users.table.dtReg')"><span >{{user.date}}</span></td>
                                        <td :data-title="$t('users.table.active')">
                                            <span ><i v-if="user.active" class="icon-checkmark2"></i></span>
                                            </td>
                                        <td>
                                            <button  type="button" class="btn btn-warning" @click="usrDataChange(user)" data-html="true" :title=" $t('users.addUsr.title.change')"><i class="icon-pencil22"></i></button>
                                            <!-- <button  type="button" class="btn btn-secondary" @click="remove(user)" data-html="true" :title=" $t('users.hint.delete')"><i class="icon-bin"></i></button> -->
                                        </td>
                                    </tr>

                                </tbody>
                            </table>
                        </div>
                        <div class="" style="text-align: center;">
                            <ul class="pagination">
                                <li class="page-item" v-if="pageNumber > 0">
                                    <a class="page-link" @click="prevPage" ><i class="icon-arrow-left2"></i></a>
                                </li>
                                
                                <li class="page-item" v-bind:class="{active : (pageNumber == (page - 1))}" v-for="(page, index) in pages" :key="index" >
                                    <a v-if="page != '...'" class="page-link" @click="pageNumber = (page - 1)">{{page}}</a>
                                    <a v-else class="page-link" :id="index">{{page}}</a>
                                </li>
                                
                                <li class="page-item" v-if="pageNumber < pageCount - 1">
                                    <a class="page-link"  @click="nextPage"><i class="icon-arrow-right2"></i></a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>

  export default {
  components: {},
    name: "Users",
    data(){
      return{
        errors: [],
        listUsers: [],
        listClients: [],
        editingUserObg:null,
        role: {
            user: false,
            dispatcher: false,
            client: false,
            service: false,
            serviceOrg: false,
            admin: false,
        },

        filterStr: "",
        changeUsr:{
            guid: "",//hidden
            username:"",
            nameClient: "",
            clientGuid: "",//hidden
            edrpo: "",
            login: "",
            password: "",
            email: "",
            phone: "",
            type: "",//always 3
            //role: "",
            roles: [],
            active:true
        },
        pageNumber: 0,

        //buttons
        editing: false,
        adding: false,
        //buttons

        showRoles: false,
      }
    },
    props:{
        size:{
            type:Number,
            required:false,
            default: 10,
        },
        paggSize:{
            type: Number,
            required:false,
            default: 5,
        }
    },
    methods: {
        getUsers() {
             let dataRequest = {
                token: this.$store.getters.getUserToken
               
                };
            this.makeQuery("/service/getUserListTender", {dataRequest : dataRequest, token: this.$store.getters.getUserToken})
            .then(result => {
                console.log(result)
                this.listUsers = result.data.data;
                // for (let i = 0; i < this.listUsers.length; i++) {
                //     this.listUsers[i].date = this.dtFormat( this.dtTZ(this.listUsers[i].date) );
                // }                
            });
        },
        usrDataChange(usr){
            this.cancelChanges()
            this.editingUserObg = usr;
           
            this.clearChange();
            if (this.adding) { this.adding = false; }
            this.editing = true;
            $('html, body').animate({scrollTop: 0}, 600);//scroll to top
            this.changeUsr.guid = usr.userGuid;
            this.changeUsr.username = usr.name;           
            this.changeUsr.login = usr.login;           
            this.changeUsr.email = usr.email;
            this.changeUsr.phone = usr.tel;
            this.changeUsr.active = usr.active;
            //this.changeUsr.role = usr.role[0];
            for (let i = 0; i < usr.role.length; i++) {
                this.changeUsr.roles.push(usr.role[i]);                
            }
            
        },
        findClient(){
            if (this.changeUsr.edrpo.length > 4){
                this.listClients = [];
                let dataRequest = {
                    edrpo: this.changeUsr.edrpo
                };
                if (dataRequest.edrpo.length > 4){
                    this.makeQuery("/service/getClient", {dataRequest: dataRequest})
                    .then(result => {
                        this.changeUsr.guidClient = result.guidClient;
                        this.changeUsr.nameClient = result.name;

                        //this.showNotification('custom-success','Search','Found client!');
                    });
                }
            }
        },
        remove(usr){
            //if role admin
            if(this.isValid(usr.userGuid)){
                let dataRequest = {
                    userGuid: usr.userGuid
                }

                this.makeQuery("/service/deleteUser", {dataRequest: dataRequest, token: this.$store.getters.getUserToken})
                .then(result => {
                    this.getUsers();
                    this.showNotification('custom-error',usr.login,'Removed ' + usr.name);
                });
            }
        },
        editUser(){
            let dataRequest = {
                    userGuid: this.changeUsr.guid,    
                 }; 
            this.editingUserObg.username != this.changeUsr.name ? dataRequest.username = this.changeUsr.name :  dataRequest.username = "" 
            this.editingUserObg.login != this.changeUsr.login ? dataRequest.login = this.changeUsr.login :  dataRequest.login = "" 
            this.editingUserObg.tel != this.changeUsr.phone ? dataRequest.tel = this.changeUsr.phone :  dataRequest.tel = "" 
            this.editingUserObg.active != this.changeUsr.active ? dataRequest.active = this.changeUsr.active :  dataRequest.active = "" 
            this.editingUserObg.email != this.changeUsr.email ? dataRequest.email = this.changeUsr.email :  dataRequest.email = "" 
            this.makeQuery("/service/editUserTender", { dataRequest: dataRequest, token: this.$store.getters.getUserToken })
                .then(result => {
                    if (result.data.status){
                         this.showNotification('custom-success','Changing','Зміни збережено');
                        this.editing = false;
                        this.getUsers();
                    }
                    else{
                         this.showNotification('custom-error','Changing','Зміни не збережено');
                    }
                   
                });
                
        },

        saveChanges(){
            let errB = false;
            if(this.editing){
                //axios "/service/editUser"
                let dataRequest = {
                    userGuid: this.changeUsr.guid,
                    username: this.changeUsr.username,
                    login: this.changeUsr.login,
                    //password: null,
                    //email: null,
                    tel: this.changeUsr.phone,
                    type: "3",            
                    active:this.changeUsr.active
                };  
                if(editingUserObg)    


                this.makeQuery("/service/editUserTender", { dataRequest: dataRequest, token: this.$store.getters.getUserToken })
                .then(result => {
                    this.showNotification('custom-success','Changing','Зміни збережено');
                    this.editing = false;
                });

            } else if(this.adding){
                let dataRequest = {
                    //userGuid: "",
                    username: this.changeUsr.username,
                    login: this.changeUsr.login,
                    password: this.changeUsr.password,
                    email: this.changeUsr.email,
                    edrpo: this.changeUsr.edrpo,
                    guidClient: this.changeUsr.guidClient,
                    nameClient: this.changeUsr.nameClient,
                    tel: this.changeUsr.phone,
                    type: "3",
                    role: this.changeUsr.roles
                };

                //якщо диспетчер або сервіс тоді не потрібен edrpo guidClient nameClient при реєстрації
                this.errors = [];
                if (!this.changeUsr.login){ this.errors.push('Login can not be empty!'); }
                if ((this.changeUsr.password == "")||(this.changeUsr.password == null)||(!this.changeUsr.password)){
                    this.errors.push('Password can not be empty!');
                }
                if (!this.changeUsr.username){ this.errors.push('Name of user can not be empty!'); }
                if (!this.changeUsr.phone){ this.errors.push('Phone can not be empty!'); }
                if (!this.changeUsr.email){ this.errors.push('E-Mail can not be empty!'); }
                if (this.changeUsr.roles.length < 1){ this.errors.push('Choose role for user!');}

                let serviceOrg = false, dispatcher = false;

                for (let i = 0; i < this.changeUsr.roles.length; i++) {
                    if(this.changeUsr.roles[i] == 'serviceOrg'){
                        serviceOrg = true;
                    }
                    if(this.changeUsr.roles[i] == 'dispatcher'){
                        dispatcher = true;
                    }
                }
                
                if ( serviceOrg || dispatcher){
                    
                    this.changeUsr.edrpo = null;
                    dataRequest.edrpo = this.changeUsr.edrpo;

                    this.changeUsr.guidClient = null;
                    dataRequest.guidClient = this.changeUsr.guidClient;

                    this.changeUsr.nameClient = null;
                    dataRequest.nameClient = this.changeUsr.nameClient;
                } else {
                    if (!this.changeUsr.edrpo){ this.errors.push('EDRPO can not be empty!'); }
                    //if (!this.changeUsr.nameClient){ this.errors.push('Client name can not be empty!'); }
                    if (!this.changeUsr.guidClient){ this.errors.push('Login can not be empty!'); }
                }

                if (this.errors.length > 0){
                    for (let i = 0; i < this.errors.length; i++) {
                        this.showNotification('custom-error','Error',this.errors[i]);
                    }
                } else {
                    this.makeQuery("/service/addUser", {dataRequest: dataRequest, token: this.$store.getters.getUserToken})
                    .then(result => {
                        this.showNotification('custom-success','Register',result);
                        this.adding = false;
                    });
                }
            }
            
            if (!errB){               
                this.getUsers();
            }
        },
        cancelChanges(){
            this.adding = false;
            this.editing = false;
            this.clearChange();
        },
        nextPage(){
            this.pageNumber++;
        },
        prevPage(){
            this.pageNumber--;
        },
        clearChange(){
            this.changeUsr.guid = null;
            this.changeUsr.username = null;
            this.changeUsr.nameClient = null;
            this.changeUsr.clientGuid = null;
            this.changeUsr.edrpo = null;
            this.changeUsr.login = null;
            this.changeUsr.password = null;
            this.changeUsr.email = null;
            this.changeUsr.phone = null;
            this.changeUsr.type = null;
            //this.changeUsr.role = null;
            this.changeUsr.roles = [];
        },
        addRole(role){
            let foundScanned = false;
            for (let j = 0; j < this.changeUsr.roles.length; j++) {
                if(this.changeUsr.roles[j] == role){
                    foundScanned = true;
                    break;
                }
            }
            if(!foundScanned){
                this.changeUsr.roles.push(role);
            }
        },
    },
    watch:{
        /*'changeUsr.role': function(){
            if (this.adding){
                if (this.changeUsr.role ){
                    if ((this.changeUsr.role == 'dispatcher')||(this.changeUsr.role =='serviceOrg')){
                        document.getElementById('edrpo').disabled = true;
                    } else {
                        document.getElementById('edrpo').disabled = false;
                    }
                }
            }
        }*/
    },
    created() {
        
    },
    mounted(){
        this.checkAuthorized().then(result => {
            this.getUsers();//first on run 
        });

        $(function () {
            $('[data-toggle="tooltip"]').tooltip()
        });
    },
    computed: {
        pageCount(){
            let l = this.listUsrSorted.length, s = this.size;
            return Math.ceil(l/s);
        },
        pages: function(){
            let arr = [];
            for (let i = 0; i < this.pageCount; i++) { 
                arr[i] = i + 1;
            }
            let divider = Math.trunc(this.paggSize/2);
            let start = this.pageNumber - divider;
            let end = this.pageNumber + divider + 1;
            if (start < 0) {
                start = 0;
            }
            let final_arr = arr.slice(start,end);
            if ((start + 1) > arr[0]){
                final_arr.unshift('...');
            }
            if(end < arr[arr.length - 1]){
                final_arr.push('...');
            }
            return final_arr;
        },
        paginatedData(){
            const start = this.pageNumber * this.size,
                end = start + this.size;
            return this.listUsrSorted.slice(start, end);
        },
        listUsrSorted: function(){
            this.pageNumber = 0;
            let find = this.filterStr.toLowerCase();
            if((find != '') && (this.listUsers.length > 0)){
                return this.listUsers.filter(function(item){
                    if (item.login.toLowerCase().indexOf(find) > -1){ return item } else
                    if ((item.nameClient != null) && (item.nameClient.toLowerCase().indexOf(find) > -1)){ return item } else
                    if ((item.tel != null) && (item.tel.toLowerCase().indexOf(find) > -1)){ return item } else
                    if ((item.name != null) && (item.name.toLowerCase().indexOf(find) > -1)){ return item }
                })
            } else {
                return this.listUsers;
            }
        },
    }
}
</script>
<style scoped>
@media only screen and (max-width: 800px) {
	.marginTR{
        margin-bottom: 1rem;
    }
    .paddingTD{
        padding: 0.5rem;
    }
	/* Force table to not be like tables anymore */
	table, thead, tbody, th, td, tr { 
		display: block; 
	}
 
	/* Hide table headers (but not display: none;, for accessibility) */
	thead tr { 
		position: absolute;
		top: -9999px;
		left: -9999px;
	}
 
	tr { border: 1px solid #ccc;}
 
	td { 
		/* Behave  like a "row" */
		border: none;
		border-bottom: 1px solid #eee; 
		position: relative;
		padding-left: 50%; 
		white-space: normal;
		text-align:left;
        min-height: 2rem;
	}
 
	td:before { 
		/* Now like a table header */
		position: absolute;
		/* Top/left values mimic padding */
		top: 6px;
		left: 6px;
		width: 45%; 
		padding-right: 10px; 
		white-space: nowrap;
		text-align:left;
		font-weight: bold;
	}
 
	/*
	Label the data
	*/
	td:before { content: attr(data-title); }
}
</style>



// WEBPACK FOOTER //
// src/pages/Users.vue